export const APP_NAME = 'openDeal';
export const OPEN_DEAL_ROOT_ROUTE = '/open-deal';
